import { Injectable, signal, computed } from '@angular/core';
import { environment } from '../../../environments/environment';

export type MaintenanceModule = keyof typeof environment.maintenance.modules;

@Injectable({ providedIn: 'root' })
export class MaintenanceService {
  private readonly BYPASS_KEY = 'maintenanceBypass';

  private readonly config = environment.maintenance;

  /** The maintenance title message */
  readonly message = computed(() => this.config.message);

  /** The maintenance subtitle */
  readonly subtitle = computed(() => this.config.subtitle);

  /** Whether global maintenance mode is active (all modules blocked) */
  readonly isGlobalActive = computed(() => {
    if (!this.config.global) return false;
    if (this.hasBypass()) return false;
    return true;
  });

  /**
   * Check if a specific module is under maintenance.
   * Returns true if global OR module-specific flag is active.
   */
  isModuleUnderMaintenance(moduleKey: MaintenanceModule): boolean {
    if (this.hasBypass()) return false;
    if (this.config.global) return true;
    return this.config.modules[moduleKey] === true;
  }

  /**
   * Legacy compatibility: returns true if global maintenance is on
   */
  readonly isActive = this.isGlobalActive;

  /**
   * Set admin bypass (allows admins to use the app during maintenance)
   */
  setBypass(enabled: boolean): void {
    if (enabled) {
      localStorage.setItem(this.BYPASS_KEY, 'true');
    } else {
      localStorage.removeItem(this.BYPASS_KEY);
    }
  }

  /**
   * Check if current user has maintenance bypass
   */
  hasBypass(): boolean {
    return localStorage.getItem(this.BYPASS_KEY) === 'true';
  }
}
